import React from "react";
import ReactDOM from "react-dom/client"; // Updated import path
import App from "./App";
import "styles/index.scss";
// import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "store/store";

const root = ReactDOM.createRoot(document.getElementById("root")); // Use createRoot

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
